import React, { useState } from 'react'
import './footer.scss'
import logo from '../../../assets/images/Logo_Sobre_Oscuro.png'
import logoTell from '../../../../shared/assets/images/Ico_Linea_Transparencia.png'
import useMobile from '../../../hooks/useMobile'
import { graphql, useStaticQuery } from "gatsby";

const Footer = props => {
    const { isGray, countriesInclude = true } = props

    const isMobile = useMobile()

    const result = useStaticQuery(
        graphql`
            query COUNTRIES_FOOTER_QUERY {
                allContentfulPaises(sort: {order: ASC, fields: titulo}, filter: {lineaDeTransparencia: {ne: null}}) {
                    nodes {
                        bandera {
                          file {
                            url
                          }
                        }
                        titulo
                        lineaDeTransparencia
                      }
                  }
            }
          `
    );

    const [listOpen, setLisOtpen] = useState(false)

    const countries = result.allContentfulPaises.nodes

    return (
        <footer className={"f-footer " + (isGray ? "gray" : '')}>
            {
                countriesInclude
                ?
                    <div className="f-info-footer-container">
                        <div className="f-transparicy-line">
                            <div className="f-description-container" onClick={() => setLisOtpen(!listOpen)}>

                                <div className="f-icon-container f-shield">
                                    <img src={logoTell} alt="icono celular" className="f-icon-transparency"/>
                                    {/* <i className="fas fa-user-shield"></i> */}
                                </div>

                                {isMobile && <div className="f-icon-container">
                                    <i className={"fas fa-plus plus " + (listOpen ? 'open' : '')}></i>
                                </div>}

                                <div className="f-description">
                                    <h3 className="f-footer-title">Línea de Transparencia</h3>
                                    <h4 className="f-footer-subtitle">Llámanos siempre que lo necesites</h4>
                                    <p className="f-footer-note">Línea confidencial atendida por personal externo</p>
                                    <p className="f-footer-note">Atención Lunes a Sábado de 7:00am - 7:00pm</p>
                                </div>

                            </div>

                            {listOpen && isMobile && <div className="f-footer-separator-line" />}

                            <div className={"f-list-country-container " + (listOpen ? 'open' : 'hidde')}>
                                {isMobile && <div className="f-description">
                                    <p className="f-footer-note">Línea confidencial atendida por personal externo</p>
                                    <p className="f-footer-note">Atención Lunes a Sábado de 7:00am - 7:00pm</p>
                                </div>}
                                {countries.map((item, index) => {
                                    return (
                                        <div className="f-country-container" key={index}>
                                            <div className="f-flag-container">
                                                <img
                                                    className="f-flag-img"
                                                    alt="Imagen pais"
                                                    src={item.bandera.file.url}
                                                />
                                            </div>

                                            <div className="f-info-country">
                                                <div className="f-country-name">
                                                    {item.titulo}
                                                </div>
                                                <div className="f-country-line">
                                                    {item.lineaDeTransparencia}
                                                </div>
                                            </div>

                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                :
                    null
            }
            <div className="f-comunication-channels-container">
                <div className="f-comunication-channels">
                    <div className="f-footer-logo">
                        <img
                            className="f-footer-logo-img"
                            alt="Logo grupo familia"
                            src={logo}
                        />
                    </div>

                    <div className="f-footer-separator-line" />

                    <h3 className="f-footer-title">Canales de comunicación</h3>

                    <div className="f-contact-list">
                        <div className="f-contact-link" >comunicacionesfam@grupofamilia.com</div>
                        <a className="f-contact-link" href='https://www.grupofamilia.com.co/' rel="noopener noreferrer" target="_blank">www.grupofamilia.com</a>
                    </div>

                    <div className="f-social-list-container">
                        <a className="f-social-icon-container" href='https://www.linkedin.com/company/grupo-familia/mycompany/' rel="noopener noreferrer" target="_blank">
                            <i className="fab fa-linkedin-in"></i>
                        </a>
                        <a className="f-social-icon-container" href='https://www.youtube.com/channel/UCyqkRv8JcYHK80Ed5uGIAIQ' rel="noopener noreferrer" target="_blank">
                            <i className="fab fa-youtube"></i>
                        </a>
                    </div>

                </div>
            </div>
        </footer>
    )
}

export default Footer
